<template>
    <v-container>
        <h1 class="titulo mb-3">CONFIGURAÇÕES DE CONSULTA E ANÁLISE DE CRÉDITO</h1>
        <div>
            <div id="tabs" class="container">
                <div class="tabs">
                    <a @click="activetab = CONFIG_CREDITANALYSIS" :class="{ active: activetab === CONFIG_CREDITANALYSIS }">
                        Configuração de Consulta e Análise de Crédito
                    </a>
                    <a @click="activetab = CONFIG_CREDITANALYSIS_GRANDES_NEGOCIOS" :class="{ active: activetab === CONFIG_CREDITANALYSIS_GRANDES_NEGOCIOS }">
                        Configuração de Grandes Negócios
                    </a>
                    <a @click="activetab = CONFIG_CREDITANALYSISEMAIL" :class="{ active: activetab === CONFIG_CREDITANALYSISEMAIL }">
                        Configuração de Notificações por E-mail
                    </a>
                    <a @click="activetab = CONFIG_CREDITANALYSIS_PENDENCIA" :class="{ active: activetab === CONFIG_CREDITANALYSIS_PENDENCIA }">
                        Configuração de Pendências
                    </a>
                </div>

                <div class="content">
                    <div v-if="activetab === CONFIG_CREDITANALYSIS" class="tabcontent">
                        <ConfigCreditAnalysis />
                    </div>
                    <div v-if="activetab === CONFIG_CREDITANALYSIS_GRANDES_NEGOCIOS" class="tabcontent">
                        <ConfigCreditAnalysisGrandesNegocios />
                    </div>
                    <div v-if="activetab === CONFIG_CREDITANALYSISEMAIL" class="tabcontent">
                        <ConfigCreditAnalysisEmail />
                    </div>
                    <div v-if="activetab === CONFIG_CREDITANALYSIS_PENDENCIA" class="tabcontent">
                        <ConfigCreditAnalysisPendencias />
                    </div>
                </div>
            </div>
        </div>
    </v-container>
</template>

<script>
  import ConfigCreditAnalysis from './ConfigCreditAnalysis.vue'
  import ConfigCreditAnalysisEmail from './ConfigCreditAnalysisEmail.vue'
  import ConfigCreditAnalysisGrandesNegocios from './ConfigCreditAnalysisGrandesNegocios.vue'
  import ConfigCreditAnalysisPendencias from './ConfigCreditAnalysisPendencias.vue'

  export default {
    name: 'ConfigCreditAnalysisAba',
    components: {
      ConfigCreditAnalysis,
      ConfigCreditAnalysisGrandesNegocios,
      ConfigCreditAnalysisEmail,
      ConfigCreditAnalysisPendencias
    },
    data: () => ({
      activetab: 'config_creditanalysis'
    }),
    computed: {
      CONFIG_CREDITANALYSIS: () => 'config_creditanalysis',
      CONFIG_CREDITANALYSIS_GRANDES_NEGOCIOS: () => 'config_creditanalysis_grandes_negocios',
      CONFIG_CREDITANALYSISEMAIL: () => 'config_creditanalysisemail',
      CONFIG_CREDITANALYSIS_PENDENCIA: () => 'config_creditanalysis_pendencias'
    }
  }
</script>

<style scoped lang="scss">

@import url('../../../assets/css/tabs.css');
</style>
